import "react-nice-dates/build/style.css";
import Loading from "../../../components/basics/Loading";

import HeaderModule from "../../../components/header/HeaderModule";

import { Divider, Grid } from "@material-ui/core";
import Filter from "./children/Filter";
import { ReportActions } from "./children/Report/ReportActions";
import ReportDataGrid from "./children/Report/ReportDataGrid";
import { ReportHeader } from "./children/Report/ReportHeader";
import {
  ContasPagarProvider,
  useContasPagarService,
} from "./context/ContasPagarContext";

const View = () => {
  const { mainLoading, mainRefetchLoading } = useContasPagarService();

  return (
    <>
      <HeaderModule title="CONTAS A PAGAR" />
      <Loading open={mainLoading || mainRefetchLoading} />
      <Grid
        container
        direction="column"
        style={{ marginTop: 80, marginBottom: 40, padding: "0px 16px" }}
        spacing={2}
      >
        <Filter />

        <ReportHeader />
        <ReportActions />
        <Divider />

        <ReportDataGrid />
      </Grid>
    </>
  );
};

const ContasPagar = (props) => (
  <ContasPagarProvider>
    <View {...props} />
  </ContasPagarProvider>
);

export default ContasPagar;
